import {
  SubmitSellThisNowFormRequestBody,
  SubmitSellThisNowFormResponse,
} from "@/app/ec/product/[basePath]/sell-this-now";
import { baseApi } from "@/store/baseApi";

export const productApi = baseApi.enhanceEndpoints({}).injectEndpoints({
  endpoints: (builder) => ({
    modifyReviewHelpfulness: builder.mutation<string, ModifyReviewHelpfulnessProps>({
      query: ({ reviewId, thumbUp }) => ({
        url: `neo/pdp/${reviewId}/modify-review-helpfulness?isHelpful=${thumbUp}`,
        credentials: "include",
        method: "POST",
        responseHandler: "text",
      }),
    }),
    addVendorProduct: builder.mutation<SubmitSellThisNowFormResponse, SubmitSellThisNowProps>({
      query: ({ mpId, saveWithWarnings, postBody }) => ({
        url: `marketplace/pdp/${mpId}/add-vendor-product`,
        params: {
          verId: process.env.NEXT_PUBLIC_VERTICAL_ID,
          saveWithWarnings: saveWithWarnings ? "true" : "false",
        },
        credentials: "include",
        method: "POST",
        body: postBody,
      }),
    }),
  }),
});

export const {
  useModifyReviewHelpfulnessMutation,
  useAddVendorProductMutation,
  util: { getRunningQueriesThunk },
} = productApi;

export const { modifyReviewHelpfulness, addVendorProduct } = productApi.endpoints;

type ModifyReviewHelpfulnessProps = {
  reviewId: number;
  thumbUp: boolean;
};

type SubmitSellThisNowProps = {
  mpId: number;
  saveWithWarnings: boolean;
  postBody: SubmitSellThisNowFormRequestBody;
};
